import React from 'react';
import styled from 'styled-components';
import {
  colors,
  fonts,
  breakpoints,
  headingStyle,
  containerStyle,
  sectionPaddingStyle,
  shadows,
} from './designSystem';

// ---------------------------------------------------------------------------
// Styled Components
// ---------------------------------------------------------------------------

const Section = styled.section`
  margin: 0;
  ${sectionPaddingStyle}
  background-color: ${colors.vertPastel};
`;

const Container = styled.div`
  ${containerStyle}
`;

const Heading = styled.h2`
  ${headingStyle}
  font-size: 1.5rem;
  margin-bottom: 24px;

  @media (min-width: ${breakpoints.mobile}) {
    font-size: 2rem;
  }
`;

const Emphasis = styled.span`
  color: ${colors.bleu};
`;

const MapFrame = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 50%;
  height: 0;
  overflow: hidden;
  border-radius: 20px;
  box-shadow: ${shadows.card};

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
    border-radius: 20px;
  }
`;

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

export default function VilleMap({ name, latitude, longitude }) {
  if (!name) return null;

  let src;
  if (latitude && longitude) {
    src = `https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d23000!2d${longitude}!3d${latitude}!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sfr!2sfr`;
  } else {
    const query = encodeURIComponent(`ateliers vélo ${name}, France`);
    src = `https://maps.google.com/maps?q=${query}&t=&z=13&ie=UTF8&iwloc=&output=embed`;
  }

  return (
    <Section>
      <Container>
        <Heading>
          Carte des ateliers &agrave; <Emphasis>{name}</Emphasis>
        </Heading>
        <MapFrame>
          <iframe
            src={src}
            title={`Carte des ateliers vélo à ${name}`}
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
          />
        </MapFrame>
      </Container>
    </Section>
  );
}
